import { FocusDTO } from "js/api/focus";

/**
 * Sort items by last used.
 *
 * Items without a lastUsed timestamp should come after any that have one. If lastUsed property is missing or the same, sort alphabetically by name.
 */
export function sortFocusItemsByLastUsed(items: FocusDTO[]): FocusDTO[] {
	return items.sort((a, b) => {
		// Handle cases where lastUsed is undefined
		if (a.lastUsed === undefined && b.lastUsed === undefined) {
			// If both are missing lastUsed, sort alphabetically by name
			return a.name.localeCompare(b.name);
		} else if (a.lastUsed === undefined) {
			// If only 'a' is missing lastUsed, place it after 'b'
			return 1;
		} else if (b.lastUsed === undefined) {
			// If only 'b' is missing lastUsed, place it after 'a'
			return -1;
		}

		// If both have lastUsed, compare by lastUsed
		if (a.lastUsed !== b.lastUsed) {
			return b.lastUsed - a.lastUsed;
		}

		// If lastUsed is the same, sort alphabetically by name
		return a.name.localeCompare(b.name);
	});
}

export function sortFocusItemsByNameAtoZ(focuses: FocusDTO[]): FocusDTO[] {
	return focuses.sort((a, b) => a.name.localeCompare(b.name));
}

export function sortFocusItemsByNameZtoA(focuses: FocusDTO[]): FocusDTO[] {
	return focuses.sort((a, b) => b.name.localeCompare(a.name));
}
